// Imports
import React from "react";

function RecNextStepsCards({ nextCardStep, nextCardTitle, nextCardDesc }) {
  return (
    <>
      <li className="rec-next-steps-card">
        <div className="rec-next-steps-card__no">{nextCardStep}</div>
        <div className="rec-next-steps-card__title">{nextCardTitle}</div>
        <div className="rec-next-steps-card__desc">{nextCardDesc}</div>
      </li>
    </>
  );
}

export default RecNextStepsCards;
